import { render } from "./StoreContent.vue?vue&type=template&id=0d1bcdb2"
import script from "./StoreContent.vue?vue&type=script&lang=js"
export * from "./StoreContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__